import React from 'react';

const CustomerAddress = ({ isSingleOption }) => {
  function message() {
    return isSingleOption
      ? "How you'll get this item:"
      : 'How do you want your item delivered?';
  }
  return (
    <>
      <h4>{message()}</h4>
    </>
  );
};

export default CustomerAddress;
